import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Turn } from 'src/app/interfaces/turn';
import { ErrorService } from 'src/app/services/error.service';
import { TurnService } from 'src/app/services/turn.service';

@Component({
  selector: 'app-turn',
  templateUrl: './turn.component.html',
  styleUrls: ['./turn.component.css']
})
export class TurnComponent implements OnInit {
  listTurns: Turn[] = [];
  loading = false;

  constructor(
    private _turnService: TurnService,
    private toastr: ToastrService,
    private _errorService: ErrorService
  ) {}

  ngOnInit(): void {
    this.getListTurns();
  }

  getListTurns() {
    this.loading = true;

    this._turnService.getListTurns().subscribe({
      next: (data: Turn[]) => {
        this.listTurns = data;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al obtener la lista de turnos:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }

  deleteTurn(id: number) {
    this.loading = true;
    this._turnService.deleteTurn(id).subscribe({
      next: () => {
        this.getListTurns();
        this.toastr.warning('El turno fue eliminado con exito', 'Turno eliminado');
      },
      error: (error) => {
        console.error('Error al eliminar el turno:', error);
        this._errorService.msjError(error);
        this.loading = false;
      }
    });
  }
}
